import { render, staticRenderFns } from "./VODFilesList.vue?vue&type=template&id=2135090f&scoped=true&"
import script from "./VODFilesList.vue?vue&type=script&lang=js&"
export * from "./VODFilesList.vue?vue&type=script&lang=js&"
import style0 from "./VODFilesList.vue?vue&type=style&index=0&id=2135090f&lang=scss&scoped=true&"
import style1 from "./VODFilesList.vue?vue&type=style&index=1&id=2135090f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2135090f",
  null
  
)

export default component.exports